import React from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet, View } from 'react-native';
import {
  Container,
  LargeHeaderTitle,
  Text,
  theme,
  useResponsive,
} from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

export const SweetpassScreenContentSignedIn = ({
  testID,
}: SweetpassScreenContentSignedInProps) => {
  const { t } = useLocalizationContext();
  const { match } = useResponsive();

  const contentWrapperStyle = [
    styles.contentWrapper,
    match([styles.contentWrapperXS, styles.contentWrapperSM]),
  ];

  return (
    <View testID={testID}>
      <LargeHeaderTitle>{t('sweetpass.signed-in.header')}</LargeHeaderTitle>

      <Container style={styles.container} wrapperStyle={contentWrapperStyle}>
        <Text>[ Placeholder ]</Text>
      </Container>
    </View>
  );
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  contentWrapper: {
    flexGrow: 1,
  },
  contentWrapperXS: {
    paddingBottom: theme.spacing.large,
  },
  contentWrapperSM: {
    paddingBottom: theme.spacing.xlarge,
  },
  container: {
    flexGrow: 1,
  },
});

// ─── TYPES ─────────────────────────────────────────────────────────────────────

type SweetpassScreenContentSignedInProps = Pick<ViewProps, 'testID'>;
